import axiosInstance from "./AxiosInstance"
import defaultAvatar from "../../src/assets/images/placeholder.jpg"

export function getPatientList() {
  return axiosInstance.post("/admin/PatientQueueList", {
    without_auth: "YES",
  })
}

export function formatPatients(data) {
  if (!data || !Array.isArray(data)) return []

  return data.map((item) => {
    const fullName = `${item.first_name || ""} ${item.middile_name || ""} ${item.last_name || ""}`.trim()
    const contact = item.whatsapp_contact_no || item.additional_contact_no || ""

    return {
      queue_id: item.queue_id,
      patient_id: item.patient_id,
      name: fullName || "N/A",
      avatar: item.patient_photo || defaultAvatar,
      time_slot: item.time_slot || "-",
      reason: item.occupation || "General Checkup",
      token_no: String(item.token_no).padStart(2, "0"),
      first_name: item.first_name,
      last_name: item.last_name,
      patient_photo: item.patient_photo,
      occupation: item.occupation,
      created_at: item.created_at,
      status: item.patient_marked || "",
      contact: contact,
      showCollectButton: item.is_payment !== "Yes",
      weight: item.weight,
      height: item.height,
      gender: item.gender,
      whatsapp_contact_no: item.whatsapp_contact_no,
      age: calculateAge(item.date_of_birth),
      // Doctor information
      doctor_id: item.doctor_id,
      doctor_name: item.doctor_name,
      // Vitals
      systolic_bp: item.systolic_bp ?? null,
      diastolic_bp: item.diastolic_bp ?? null,
      bmi: item.bmi ?? null,
      pluse_rate: item.pluse_rate ?? null,
      temperature: item.temperature ?? null,
      Oxygen_Saturation: item.Oxygen_Saturation ?? null,
      blood_glucose_level: item.blood_glucose_level ?? null,
      Allergies: item.Allergies ?? null,
      Reports_Upload: item.Reports_Upload ?? null,
      // Additional
      diseases: item.diseases || "",
      is_firsttime_visitor: item.is_firsttime_visitor === "Yes",
      is_pause:item.is_pause,
    }
  })

  function calculateAge(dob) {
    if (!dob) return null
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    const dayDiff = today.getDate() - birthDate.getDate()
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--
    }
    return age
  }
}

// Helper function to group patients by doctor with sequential OPD numbers
export function groupPatientsByDoctor(patients) {
  const doctorGroups = {}

  patients.forEach((patient) => {
    const doctorId = patient.doctor_id || "0"
    const doctorName = patient.doctor_name || "General"

    if (!doctorGroups[doctorId]) {
      doctorGroups[doctorId] = {
        doctor_id: doctorId,
        name: doctorName,
        specialty: "General Medicine",
        currentPatient: null,
        queue: [],
      }
    }

    if (patient.status === "Current") {
      doctorGroups[doctorId].currentPatient = {
        name: patient.name,
        token: Number.parseInt(patient.token_no),
        avatar: patient.avatar,
        gender: patient.gender,
      }
    } else {
      doctorGroups[doctorId].queue.push({
        id: patient.patient_id,
        name: patient.name,
        token: Number.parseInt(patient.token_no),
        time_slot: patient.time_slot,
        avatar: patient.avatar,
        gender: patient.gender,
      })
    }
  })

  // Convert to array and assign sequential OPD numbers
  return Object.values(doctorGroups)
    .filter((doctor) => doctor.currentPatient || doctor.queue.length > 0)
    .map((doctor, index) => ({
      ...doctor,
      id: index + 1, // Sequential OPD number: 1, 2, 3, etc.
    }))
}

